export enum ImageFitTypes {
  COVER = 'cover',
  CONTAIN = 'contain',
  FILL = 'fill',
  INSIDE = 'inside',
  OUTSIDE = 'outside',
}

export enum ImageFormatTypes {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  WEBP = 'webp',
  TIFF = 'tiff',
  HEIF = 'heif',
  HEIC = 'heic',
  RAW = 'raw',
}

interface ImageHandlerEdits {
  toFormat?: ImageFormatTypes;
  resize?: {
    width: number;
    height: number;
    fit?: ImageFitTypes;
  };
  crop?: {
    left?: number;
    top?: number;
    width?: number;
    height?: number;
  };
  background_color?: string;
  /** <radius>,<sigma> */
  blur?: string;
  normalize?: boolean;
  grayscale?: boolean;
  tint?: {
    r?: number;
    g?: number;
    b?: number;
  };
  rotate?: number;
  sharpen?: number;
  overlayWith?: {
    bucket: string;
    key: string;
    alpha?: number;
    wRatio?: number;
    hRatio?: number;
    options?: {
      left?: number;
      top?: number;
    };
  };
}

export interface ImageHandlerRequest {
  bucket: string;
  key: string;
  edits: ImageHandlerEdits;
}
